import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// import image
import roboticsLogo from "../../image/Logo_robotics.svg";
import bannerImg from "../../image/robotics/exmachina.jpg";
import sectionImg from "../../image/robotics/lab.jpeg";
import aiiaMachineFrame from "../../image/robotics/aiia_machine7.png";
import aiiaVideo from "../../image/robotics/aiia_vid.mp4";
// import data
import contentData from "../../data/content/robotics/roboticsContent.json";
import { DataStructure } from "../../types";
// import doc
import aiiaBrochure from "../../docs/Graphen Brochure dec 9 2024.pdf";
// import components
import { NavTree } from "../navigation/NavLinkPages";
import { MainFrame, Col2ContentFrame, SpacingFrame, Col3ContentFrame } from "../display/Frame";
import { BusinessBannerSection, BannerSection, StatsSection } from "../display/Sections";
import { ImageImport, ImageBanner } from "../display/ImageFormat";
import { TextBody, TitleSubtitle } from "../display/TextFormat";
import { PDFViewer } from "../tools/Viewer";
import { ArdiToolsOverview, ApplicationAreasOverview } from "../content/ToolsOverview";
import { MoreButton } from "../tools/Buttons";
import { AiiaHardwareModels, AiiaRolesSlideShow } from "../content/DigitalHuman";
import { SlideInAnim } from "../tools/Animations";
// import functions
import { DisplayInfo2Cols, DisplayProductCards, DisplayProductCardsNoLink } from "../../functions/DisplayInfoFunctions";
import { RobotProductCard } from "../display/Cards";
// import context
import { useLang } from "../Context";
// import global var
import { maxWidthScreen } from "../GlobalVar";

const typedContent : DataStructure = contentData;
const imagePath = "image/robotics/";

//////////////////////
// LOCAL FUNCTIONS //
/////////////////////
interface BannerProps {
    title: string;
    subtitle: string;
};
function DefaultBanner({ title, subtitle } : BannerProps) {
    return (
        <BannerSection image={bannerImg} title={ title } subtitle={ subtitle } />
    )
};


export default function Robotics() {
    const { lang } = useLang();
    const location = useLocation();
    const data = typedContent["Robotics"];

    // Handle section navigation based on URL path
    useEffect(() => {
        const pathname = location.pathname;
        let targetId = "";

        if (pathname.includes("/aiter-robots")) {
            targetId = "aiter-robots";
        } else if (pathname.includes("/robotics-labs")) {
            targetId = "robotics-labs";
        }

        if (targetId) {
            setTimeout(() => {
                const element = document.getElementById(targetId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 500); // 增加延遲確保頁面已完全載入
        }
    }, [location.pathname]);
    const section0 = data[0];
    const section1 = data[1];
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];
    const section5 = data[5];
    const section6 = data[6];
    const section7 = data[7];
    const section8 = data[8];
    const section9 = data[9];

    return (
        <>
            <BusinessBannerSection
                bgImage={ bannerImg }
                logoImage={ roboticsLogo }
                title={ data["title"][lang] }
                subtitle={ data["subtitle"][lang] }
            />

            <NavTree />

            <DisplayInfo2Cols contentData={ section0["content"] } imagePath={imagePath} title={ section0["title"][lang] } subtitle={ section0["subtitle"][lang] } />

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <SpacingFrame>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <Col3ContentFrame>
                        <DisplayProductCardsNoLink data={ section1["solutions"] } />
                    </Col3ContentFrame>
                </SpacingFrame>
            </MainFrame>

            {/* Aiter Series Section */}
            <MainFrame id="aiter-robots">
                <SpacingFrame>
                    <TitleSubtitle title={section9["title"][lang]} subtitle={section9["subtitle"][lang]} left/>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                        <div className="self-start lg:mt-0">
                            <RobotProductCard data={section9["content"]["0"]} imagePath={imagePath} />
                        </div>
                        <div className="self-end lg:mt-64">
                            <RobotProductCard data={section9["content"]["1"]} imagePath={imagePath} />
                        </div>
                    </div>
                </SpacingFrame>
            </MainFrame>

            <ImageBanner image={sectionImg} />

            <MainFrame pt={128} pb={64} id="robotics-labs">
            <TitleSubtitle title={ section8["title"][lang] } subtitle={ section8["subtitle"][lang] } spacing={30} left/>
            </MainFrame>


            <MainFrame pt={64} pb={64}>
            <div className=" rounded-3xl px-6 py-12 lg:px-12 " style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <DisplayInfo2Cols contentData={section2} imagePath={imagePath} pt={0} pb={0}/>
            </div>
            </MainFrame>

            <MainFrame pt={64} pb={64}>
            <div className=" rounded-3xl px-6 py-12 lg:px-12" style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <DisplayInfo2Cols contentData={section3} imagePath={imagePath} pt={0} pb={0}/>
            </div>
            </MainFrame>

            <MainFrame pt={64} pb={64}>
            <div className=" rounded-3xl px-6 py-12 lg:px-12" style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <DisplayInfo2Cols contentData={section4} imagePath={imagePath} pt={0} pb={0}/>
            </div>
            </MainFrame>

            <MainFrame pt={64} pb={64}>
            <div className=" rounded-3xl px-6 py-12 lg:px-12" style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <DisplayInfo2Cols contentData={section5} imagePath={imagePath} pt={0} pb={0}/>
            </div>
            </MainFrame>

            <MainFrame pt={64} pb={128}>
            <div className=" rounded-3xl px-6 py-12 lg:px-12" style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <DisplayInfo2Cols contentData={section6} imagePath={imagePath} pt={0} pb={0}/>
            </div>
            </MainFrame>

            <ApplicationAreasOverview />

            <DisplayInfo2Cols contentData={section7} imagePath={imagePath} smallerPadding/>





        </>
    )
};

export function AiiaBrochurePDF() {
    return (
        <PDFViewer src={aiiaBrochure} />
    )
};


export function Aiia() {
    const { lang } = useLang();
    const data = typedContent["digital-human"];
    const section1 = data[1];
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];
    const section5 = data[5];
    const section6 = data[6];

    let aiiaFeatures = Object.keys(section4["content"]).map((i) => {
        let data = section4["content"][i];
        let image = require("../../image/icons/" + data["icon"]);
        return (
            <div className="w-full h-fit flex flex-col items-center justify-center gap-8">
                <div className="relative w-20 h-20 rounded-full bg-teal-500">
                    <div className="absolute w-20 h-20 flex items-center justify-center">
                        <img className="w-10 h-10" src={ image } />
                    </div>
                </div>
                <SpacingFrame spacing={12}>
                    <p className="text-md font-semibold text-grey-800">{ data["title"][lang] }</p>
                    <p className="text-sm text-grey-400">{ data["subtitle"][lang] }</p>
                </SpacingFrame>
            </div>
        )
    });


    return (
        <main className="overflow-x-clip">
            <div className="relative w-full h-screen bg-cover bg-center bg-grey-800 bg-blend-color-burn overflow-hidden">
                <div className="absolute w-[782px] h-[782px] rounded-full blur-3xl filter opacity-60 top-[15%] left-[43%]" style={{ backgroundColor: "#57CBB6" }}/>
                <div className="absolute w-[616px] h-[616px] rounded-full blur-3xl filter opacity-60 top-[64%] left-[11%]" style={{ backgroundColor: "#5B68DF" }}/>

                <div className="absolute inset-x-0 top-0 flex w-full justify-center lg:mt-0 sm:mt-20">
                    <div
                        className="flex h-screen w-full flex-col items-center gap-8 sm:p-10 lg:grid lg:grid-cols-5 lg:items-center lg:gap-8 lg:p-0"
                        style={{ maxWidth: `${maxWidthScreen}px` }}
                    >
                        <div className="col-span-2 m-auto flex w-fit max-w-full flex-col gap-4 break-words px-4 lg:px-0">
                            <p className="text-left text-2xl font-bold text-white break-words lg:leading-tight sm:leading-none">{ data["title"][lang] }</p>
                            <p className="text-left font-light leading-relaxed text-white break-words">{ data["subtitle"][lang] }</p>
                        </div>
                        <div className="relative col-span-3 flex w-full justify-center lg:mt-[12vh]">
                            <div className="relative w-[min(96vw,560px)] shrink-0 lg:w-full lg:max-w-[700px]">
                                <img
                                    className="relative z-10 mx-auto block h-auto w-full pointer-events-none"
                                    src={aiiaMachineFrame}
                                    alt=""
                                    aria-hidden="true"
                                />
                                <div
                                    className="absolute left-[28.06%] top-[14.06%] z-20 h-[53.63%] w-[42.96%] overflow-hidden"
                                    aria-hidden="true"
                                >
                                    <video
                                        className="h-full w-full object-cover object-bottom"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        src={aiiaVideo}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <NavTree />

            <MainFrame>
                <Col2ContentFrame>
                    <SpacingFrame spacing={20}>
                        <TitleSubtitle title={ section1["title"][lang] } subtitle={ section1["subtitle"][lang] } left />
                        <TextBody text={ section1["text"][lang] } />
                        <MoreButton label="Download Aiia PDF" link="https://www.drugomics.graphen.ai/doc/brochure.pdf" newTab={true} />
                        {/* <MoreButton label="Download Aiia PDF" link="/robotics/aiia-brochure" /> */}
                    </SpacingFrame>
                    <SlideInAnim direction="right">
                        <ImageImport image={ section1["image"] } imagePath={imagePath} />
                    </SlideInAnim>
                </Col2ContentFrame>
            </MainFrame>

            <MainFrame style={{ backgroundColor: "rgba(162, 218, 219, 0.4)" }}>
                <StatsSection title={ section2["title"][lang] } subtitle={ section2["subtitle"][lang] } data={ section2["content"] } />
            </MainFrame>

            <div className="w-full h-fit overflow-hidden">
                <div className="m-auto" style={{ maxWidth: `${maxWidthScreen}px` }}>
                    <div className="w-full h-fit pt-32 sm:px-8">
                        <SpacingFrame spacing={20}>
                            <TitleSubtitle title={ section3["title"][lang] } subtitle={ section3["subtitle"][lang] } />
                            <SlideInAnim direction="bottom">
                                <ImageImport image={ section3["image"] } imagePath={imagePath} />
                            </SlideInAnim>
                        </SpacingFrame>
                    </div>
                </div>
            </div>

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)", overflow: "hidden" }}>
                <SpacingFrame>
                    <TitleSubtitle title={ section4["title"][lang] } />
                    <SlideInAnim direction="bottom">
                        <Col3ContentFrame>
                            { aiiaFeatures }
                        </Col3ContentFrame>
                    </SlideInAnim>
                </SpacingFrame>
            </MainFrame>

            <MainFrame>
                <SpacingFrame>
                    <TitleSubtitle title={ section5["title"][lang] } />
                    <AiiaRolesSlideShow />
                </SpacingFrame>
            </MainFrame>

            <AiiaHardwareModels />

            <DisplayInfo2Cols contentData={section6["content"]} imagePath={imagePath} title={ section6["title"][lang] } />
        </main>
    )
};


export function StoreSolutions() {
    const { lang } = useLang();
    const data = typedContent["store-solutions"];
    const contentData = data["content"];

    return (
        <>
            <DefaultBanner title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />

            <DisplayInfo2Cols contentData={contentData} imagePath={imagePath} />
        </>
    )
};



export function Adam() {
    const { lang } = useLang();
    const data = typedContent["adam"];
    const contentData = data["content"];

    return (
        <>
            <DefaultBanner title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />

            <DisplayInfo2Cols contentData={contentData} imagePath={imagePath} />
        </>
    )
};